import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./eduDocumentsTour.css";

export function startEduDocumentsPageTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour giới thiệu các vùng chính của trang Tài liệu học tập: lọc dữ liệu, danh sách thẻ và thao tác thêm tài liệu.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="edu-documents-header"]',
      title: "Tiêu đề & ngữ cảnh",
      description:
        "Hiển thị số tài liệu đang được hiển thị sau khi áp dụng bộ lọc hiện tại.",
      side: "bottom",
    },
    {
      selector: '[data-tour="edu-documents-header-guides"]',
      title: "Cụm nút hướng dẫn",
      description:
        "Icon lấp lánh mở tour trang; icon file mở tour modal thêm tài liệu; icon dấu hỏi mở hướng dẫn chi tiết.",
      side: "left",
    },
    {
      selector: '[data-tour="edu-documents-filter"]',
      title: "Bộ lọc tài liệu",
      description:
        "Tìm theo tên tài liệu, lọc theo môn học, phân loại, định dạng và trạng thái.",
      side: "bottom",
    },
    {
      selector: '[data-tour="edu-documents-grid"]',
      title: "Danh sách tài liệu",
      description:
        "Bấm vào từng thẻ để mở chi tiết, xem/sửa/xóa tùy quyền.",
      side: "top",
    },
    {
      selector: '[data-tour="edu-documents-upload-queue"]',
      title: "Hàng đợi upload",
      description:
        "Khi tải nhiều file, hệ thống hiển thị tiến trình từng file tại góc phải dưới.",
      side: "left",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy tải lại trang và thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "edu-documents-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
